angular.module('gym.contacts').controller('MembershipReplacementModalCtrl', ["$scope", "$state", "$modalInstance", "MembershipPlans", "contact", "membership", function($scope, $state, $modalInstance, MembershipPlans, contact, membership) {
  var plansParams;
  $scope.contact = contact;
  $scope.membership = membership;
  plansParams = {
    count: 1000,
    'filters[show_when_adding_membership_internally]': true,
    'sorting[custom]': 'asc'
  };
  $scope.membershipPlans = MembershipPlans.getList(plansParams).$object;
  $scope.params = {
    old_membership_id: membership.id,
    direction: 'upgrade'
  };
  $scope.submit = function() {
    $scope.loading = true;
    $scope.errors = {};
    return $scope.contact.all('membership_replacements').doPOST($scope.params).then(function(data) {
      var params, reason, ref, ref1;
      $modalInstance.close();
      if ((ref = $scope.params.targetMembershipPlan) != null ? ref.id : void 0) {
        reason = $scope.params.direction === 'upgrade' ? `Upgrading to ${$scope.params.targetMembershipPlan.label}` : `Downgrading to ${$scope.params.targetMembershipPlan.label}`;
      }
      params = {
        contactId: contact.id,
        membershipId: membership.id,
        membershipReplacementId: data.id,
        targetMembershipId: ((ref1 = $scope.params.targetMembershipPlan) != null ? ref1.id : void 0) || void 0,
        reason: reason || ''
      };
      return $state.go('gym.contacts.addMembershipCancellation', params);
    }, function(response) {
      $scope.errors = response.data.errors || response.data;
      return $scope.loading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
